import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';
import { useHistory, useParams, useLocation } from "react-router-dom";

import './styles.scss';

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Alert, ExpandableSection, Tiles,
    Container, Header, ColumnLayout, Spinner, Link, Tabs, Button, Table, SpaceBetween, Modal, FileUpload
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import { useAuth } from "../../context/AuthContextProvider";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import Amplify, { Storage } from 'aws-amplify';
import { getLogicoS3Config } from 'src/utilities/AWSServices';

import MJEmonitoringSampleFile from '../../images/MJEMonitoringSampleFile.png'
import { PORTAL } from "src/constants/AppConstants";
import { setCurrentAppId } from '../../store/userAuthSlice';
import * as XLSX from 'xlsx';
import { createLogicoTransactions } from "src/Ateam-BI/Templates/Utils/AppActivityUtils"
import { getLogicoProcessById, logicoFileUpload, updateLogicoProcessComment } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus"
import {  LOGICO_STATUS, PROCESS_KEYS, RULES_SHEET_COLUMNS, LOGICO_FILE_UPLOAD_KEYS } from './Constants';
import { configureLogicoS3, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isUploaderAllowed } from './AccessUtilities';
import {request as requestPlugin} from 'src/plugins/CorpReportingUploadAccess'
import { getQuarterForUpload } from '../CorpReporting/Utility';
import { checkIfSupportAdmin, isMemberOf } from 'src/checkPageAccess';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import {  uploadDocumentToVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';

import ProcessCommentSection from '../Templates/components/ProcessCommentSection';
export default (props) => {
    const userId = useSelector((globalState) => globalState.auth.userId)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    
    const history = useHistory();
    let { id: paramId } = useParams();
    let { lpid: paramLpid } = useParams();
    const id = props.id || paramId;
  	const lpid = props.lpid || paramLpid;
    const [processData, setProcessData] = useState({})
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState();
    const dispatch = useDispatch()
    const [activeTabId, setActiveTabId] = useState("first");
    const [isFileSelected, setIsFileSelected] = useState(false);
    const [showFileNotSeleted, setShowFileNotSeleted] = useState(false);
    const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const [showLoadingIcon, setShowLoadingIcon] = useState(false);
    const [columnsList, setColumnsList] = useState({})
    const [items, setItems] = useState([])
    const [previewItems, setPreviewItems] = useState([])
    const [fileName, setFileName] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [mainErrorMessage, setMainErrorMessage] = useState('');
    const [missingFields, setMissingFields] = useState(new Set());
    const [colsNotInRequiredOrder, setColsNotInRequiredOrder] = useState(false);
    const [colCountNotAsExpected, setColCountNotAsExpected] = useState(false);
    const [inputFiles, setInputFiles] = useState([]);
    const [supportedFormats, setSupportedFormats] = useState('.xlsx');
    const [loadingMessage, setLoadingMessage] = useState('loading, please wait..');
    const [showUploadBtn, setShowUploadBtn] = useState(false)
    const [fileReference, setFileReference] = useState('');
 
    const [backUrl, setBackUrl] = useState(null)
    const [submitDisabled, setSubmitDisabled] = useState(false);
  
    const [providedCoulumns, setProvidedCoulumns] = useState([])
    const [comments, setComments] = useState(null)
    const [rulesSheetNotPresent, setRulesSheetNotPresent ] = useState(false)
    const [fileToBeUploaded, setFileToBeUploaded] = useState()
    const [isCommentSubmitting, setIsCommentSubmitting] = useState(false)
    
    // Comment functionality - using Redux selector
    const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)

    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.LOGICO);

    useEffect(() => {
        configureLogicoS3()
        if (lpid) {
            loadData();
        }
        if(id){
            dispatch(setCurrentAppId(id))
        }
        setBackUrl(getParam('back'))
        return () => {
            // this now gets called when the component unmounts
            configureGenericS3()
        };
    }, []);



    useEffect(() => {
        configureLogicoS3()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [isCurrentAppAuthorised]);

    useEffect(() => {
        if (isAuthorized === true || isAuthorized === false) {
            setIsCheckingAccess(!isCheckingAccess);
        }
    }, [isAuthorized]);

    
    const getParam= (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
      }
    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        setLoadingMessage("loading, please wait...")
        setShowLoadingIcon(true);
        setShowUploadBtn(false)
        await Promise.all([
            new Promise((resolve, reject) => {
                getLogicoProcessById(lpid, async function onSuccess(response) {
            const r = response.data.getLogicoProcessByID
            setProcessData(r)
            setSupportedFormats(getSupportedFormats())

            let isAllowed = await checkIfSupportAdmin(userId, currentStage)
            if(!isAllowed){
                isAllowed = await isUploaderAllowed(r, userId, currentStage)
            }
            if(!isAllowed){
                setShowLoadingIcon(false);
                setShowUploadBtn(false)
                setErrorMessage("Cannot upload input file. Please check with the owner of the process for access.")
            } else {
                setShowLoadingIcon(false);
                setShowUploadBtn(true)
            }
            resolve();
            }, function onFailure(response) {
                setErrorMessage("Could not load process information")
                setShowLoadingIcon(false);
                setShowUploadBtn(true)
                reject();
            })
            })])
        
    } finally {
        if(!pageLoadTime.isStopped) {
        stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.LOGICO)
        }
    }
    }

    const getAllowedFileFormats = () => {
        return ['Excel']
    }
 

    const isAllowedFileFormat = (format, allowedFileFormats) => {
        let isAllowed = false
        // console.log(format)
        if (!format) {
            isAllowed = false
        }
        let supportedFormats = []
        for (let i = 0; i < allowedFileFormats.length; i++) {
            if (allowedFileFormats[i] == 'CSV') {
                supportedFormats.push('text/csv')
                supportedFormats.push('text/plain')
                supportedFormats.push('text/x-csv')
                supportedFormats.push('application/vnd.ms-excel')
                supportedFormats.push('application/csv')
                supportedFormats.push('application/x-csv')
                supportedFormats.push('text/comma-separated-values')
                supportedFormats.push('text/x-comma-separated-values')
                supportedFormats.push('text/tab-separated-values')
            } else if (allowedFileFormats[i] == 'Excel') {
                supportedFormats.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                supportedFormats.push('application/vnd.ms-excel.sheet.macroenabled.12')
            }
        }
        isAllowed = supportedFormats.some(item => format === item);
        return isAllowed
    }
    const validateInputFileFormat = (file) => {
        let allowedFileFormats = getAllowedFileFormats()
        let isAllowed = isAllowedFileFormat(file?.type, allowedFileFormats)
        if (!file?.type) {
            throw new Error("Please upload an input file")
        }
        if (!isAllowed) {
            throw new Error(`File format is not allowed : ${file?.type}`);
        }
        return isAllowed
    }

    const validateFileInputColumnNames = (inputColumnNames) => {
        
        let missingFields = new Set()
        missingFields.clear()
        let columnsNotInRequiredOrder = false;
        let mandatoryColumns = RULES_SHEET_COLUMNS
        mandatoryColumns.forEach((column, index) => {
            if (!inputColumnNames.includes(column)) {
                missingFields.add(column)
            }
            if(mandatoryColumns[index] !== inputColumnNames[index]) {
                columnsNotInRequiredOrder = true;
            }
        });
        let columnCountNotAsExpected = inputColumnNames.length !== mandatoryColumns.length 
            return {'missingFields': missingFields, 'columnsNotInRequiredOrder': columnsNotInRequiredOrder, 
            'columnCountNotAsExpected': columnCountNotAsExpected, 'inputColumnNames': inputColumnNames}
    }

    const validateEmptyContents = (rowData) => {
        if (!rowData || rowData.length == 0) {
            throw new Error("The inputs rows are empty")
        }
    }

    const resetValidationErrorLogs = () => {
        setProvidedCoulumns([])
        setMissingFields(new Set())
        setColCountNotAsExpected(false)
        setColsNotInRequiredOrder(false)
        setRulesSheetNotPresent(false)
    }
    
  

    const validateUploadedFile = (workbook) => {
        let result = []
        let rulesSheet = workbook.Sheets["Rules"]
        if(rulesSheet) {
            try {
                let jsonData = XLSX.utils.sheet_to_json(rulesSheet, { header: 1, defval: "" })
                jsonData = jsonData.slice(3)
                const colNames = jsonData[0].slice(1,39)
                let validationResponse = validateFileInputColumnNames(colNames)
                setProvidedCoulumns(validationResponse.inputColumnNames)
                setMissingFields(validationResponse.missingFields)
                setColCountNotAsExpected(validationResponse.columnCountNotAsExpected)
                setColsNotInRequiredOrder(validationResponse.columnsNotInRequiredOrder)
                if (validationResponse.missingFields.size >= 1 || validationResponse.columnsNotInRequiredOrder || validationResponse.columnCountNotAsExpected) {
                    setLoadingMessage("")
                    setShowLoadingIcon(false)
                    return "ERROR"
                }else{
                    setLoadingMessage("")
                    setShowLoadingIcon(false)
                    const definitions = colNames.map((colName,index) => ({
                        id: colName,
                        header: colName,
                        cell: item => item[index + 1] || '-'
                    }))
            
            
                    setColumnsList(definitions)

            
                    setItems(jsonData)
                    const slicedArray = jsonData.slice(1, 101);
                    setPreviewItems(slicedArray)
                    setShowLoadingIcon(false)
                    setActiveTabId('second')
                    return "SUCCESS"

                }

            } catch (e) {
                console.log(e)
            }
        } else {
            //rulesSheet does not exist
            setRulesSheetNotPresent(true)
            setLoadingMessage("")
            setShowLoadingIcon(false)
            return "ERROR"

        }
        return result
    }

  

    const validateFileSize = (fileDesc) => {
        if(fileDesc.size/1000000 >= 200){
            throw ({error: 'FILE MAX LIMIT', message:"Max file limit is 200MB"})
        }else{
            setErrorMessage()
        }
    }

    const changeHandler = async (inputFiles) => {
        try {
            if(inputFiles.length >= 1) {
                setFileToBeUploaded()
            setLoadingMessage("loading file, please wait...")
            setShowLoadingIcon(true);
            setErrorMessage('')
            setIsFileSelected(true)
            setShowFileNotSeleted(false)
            const file = inputFiles[0]
            validateFileSize(file)
            validateInputFileFormat(file)
            setFileName(file.name)
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data)
            resetValidationErrorLogs()
             
            // validate sheet
            
            let message = validateUploadedFile(workbook)

            if (message === 'SUCCESS') {
                setFileToBeUploaded(data)
            }
        } else {
            setErrorMessage(`Please Choose a file.`)
        }
            
        

        } catch (error) {
            setErrorMessage(error?.message)
            setLoadingMessage("")
            setShowLoadingIcon(false)
        }

    }

    const onSubmitClick = async () => {
        
            setSubmitDisabled(true)
            setShowLoadingIcon(true)
            let sessionId = uuidv4()

            let folder = `source/${sessionId}/`
            const fnArray = fileName.split('.')
            const contentType = fnArray[fnArray.length - 1]
            let fn = folder + sessionId + '.' + contentType
            let level = "public"
            let prefix = 'logico/'
            let s3_config = getLogicoS3Config()
            let bucket_name = s3_config.S3.aws_user_files_s3_bucket
            
            let dt = moment().format();
            setLoadingMessage("uploading file for processing, please wait...")
            configureLogicoS3()
            const result = await uploadDocumentToVault(contentType, VAULT_SERVICES.LOGICO, {"file_path": `logico/${fn}`, "tagging": `userId=${userId}&app_id=${id}&logico_process_id=${lpid}`, "service_id":`${lpid}`, "app_id":`${id}`}, fileToBeUploaded)
            // console.log(result)
            // Storage.vault.put(fn, fileToBeUploaded , {
            //     tagging: `userId=${userId}&app_id:${id}&logico_process_id:${lpid}`,
            //     level: level,
            //     customPrefix: { public: prefix },
            //     acl: 'bucket-owner-full-control'
            // }).then(result => {
            createLogicoTransactions(sessionId, id, lpid, LOGICO_STATUS.UPLOADED, bucket_name, `${result?.objectKey}`, Date.now(), userId,
                function onSuccess(response) {

                    const uploadData = {}
                    uploadData[LOGICO_FILE_UPLOAD_KEYS.app_id] = id
                    uploadData[LOGICO_FILE_UPLOAD_KEYS.logico_process_id] = lpid
                    uploadData[LOGICO_FILE_UPLOAD_KEYS.file_id] = sessionId
                    uploadData[LOGICO_FILE_UPLOAD_KEYS.filepath] = `s3://${bucket_name}/${result?.objectKey}`
                    uploadData[LOGICO_FILE_UPLOAD_KEYS.s3_bucket_name] = bucket_name
                    uploadData[LOGICO_FILE_UPLOAD_KEYS.updated_by] = userId

                    logicoFileUpload(uploadData, function onSuccess(response) {
                    }, function onFailure(response) {
                        setMainErrorMessage(`File was uploaded successfully. But there was an issue triggering logico glue job for fileId : ${sessionId}`)
                        setShowLoadingIcon(false)
                        setSubmitDisabled(false)
                    })

                    setFileReference(sessionId)
                    setShowSuccessModal(true)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                }, function onFailure(response) {
                    setMainErrorMessage(`File was uploaded successfully. But, there was an issue processing, fileId : ${sessionId}`)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                })
            // }, function (error) {
            //     setMainErrorMessage("File was not uploaded successfully")
            //     setShowLoadingIcon(false)
            //     setSubmitDisabled(false)
            // })


    }

    const prevButtonClick = () => {
        setActiveTabId('first')
        setShowSuccessModal(false)
    }

    const cancelButtonClick = () => {
        setActiveTabId('first')
        setShowSuccessModal(false)
        setIsFileSelected(false)
        setInputFiles([])
    }

    const next1Click = () => {

        setActiveTabId('third')

    }

    const ModalOkClick = () => {
        // Check if we have sidebar content (query parameter context)
        if (props.selectedSidebarContent) {
            // Find the History tab and trigger its action
            const historyTab = props.selectedSidebarContent.find(
                tab => tab.label.toLowerCase() === 'history'
            );
            
            if (historyTab && historyTab.action) {
                // Close the modal first
                setShowSuccessModal(false);
                // Trigger the History tab action (updates parent state + URL)
                historyTab.action();
            } else {
                // Fallback if History tab not found
                setShowSuccessModal(false);
                history.push(`/App/${id}/LogicoProcess/${lpid}/history`);
            }
        } else {
            // Fallback to original behavior if not in query parameter context
            history.push(`/App/${id}/LogicoProcess/${lpid}/history`);
        }
    }


    const getSupportedFormats = () => {
        let returnValue = new Set()
        returnValue.add('.xls')
        returnValue.add('.xlsx')
        returnValue.add('.xlsm')
        return Array.from(returnValue).join(",")
    }

    // Process Comment Functions using custom_attributes
    const handleProcessCommentUpdate = (commentText, onSuccess, onFailure) => {
        setIsCommentSubmitting(true);
        updateLogicoProcessComment(
            lpid,
            commentText,
            userId,
            (result) => {
                // Success callback - reload process data
                setIsCommentSubmitting(false);
                loadData();
                if (onSuccess) {
                    onSuccess(result);
                }
            },
            (error) => {
                // Failure callback
                setIsCommentSubmitting(false);
                console.error('Error updating process comment:', error);
                if (onFailure) {
                    onFailure(error);
                }
            }
        );
    };

    const onFollowHandler = (ev) => {

        ev.preventDefault();
        if (ev.detail.href) {
            history.push(ev.detail.href.substring(1));
        }
    }
    const content = (
        <div>
            <div>
                <SpaceBetween size='l'>
                    {/* Process Comment Section using custom_attributes */}
                    {/* <ProcessCommentSection
                        processData={processData}
                        processType="LOGICO"
                        onCommentUpdate={handleProcessCommentUpdate}
                        isAteamBiMember={isSupportAdmin}
                        loading={showLoadingIcon}
                        isSubmitting={isCommentSubmitting}
                    /> */}
                    <Container
                        header={
                            <Header
                                variant='h2'
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant='normal' onClick={() => { 
                                            if (props.selectedSidebarContent) {
                                                const historyTab = props.selectedSidebarContent.find(
                                                    tab => tab.label.toLowerCase() === 'history'
                                                );
                                                
                                                if (historyTab && historyTab.action) {
                                                    historyTab.action();
                                                } else {
                                                    history.push(`/App/${id}/LogicoProcess/${lpid}/history`);
                                                }
                                            } else {
                                                history.push(`/App/${id}/LogicoProcess/${lpid}/history`);
                                            }
                                        }}>
                                            View Upload History
                                        </Button>
                                    </SpaceBetween>
                                }
                                description=""
                            > Upload file history


                            </Header>
                        }
                    >
                        {
                            processData?.hasOwnProperty(PROCESS_KEYS.team) && processData?.hasOwnProperty(PROCESS_KEYS.business)
                                && processData?.hasOwnProperty(PROCESS_KEYS.dataset_name) ?
                                <SpaceBetween size='s' direction='horizontal'>
                                    <Box variant="h4"> Load table : </Box>
                                    {
                                        processData[PROCESS_KEYS.redshift_table_name] ?
                                            <Box>{processData[PROCESS_KEYS.redshift_table_name]}</Box> :
                                            <Box variant="p"> {processData[PROCESS_KEYS.team]}_{processData[PROCESS_KEYS.business]}_{processData[PROCESS_KEYS.dataset_name]}</Box>
                                    }                            </SpaceBetween> : <></>
                        }
                    </Container>
                   

                    {showLoadingIcon ? (
                        <Box>
                            <Spinner size="normal"></Spinner>
                            {loadingMessage}
                        </Box>) : ''}

                    <Tabs
                        activeTabId={activeTabId}
                        variant='container'
                        tabs={[
                            {
                                activeTabId: { activeTabId },
                                label: "Step 1 : Upload File",
                                id: "first",
                                content: (
                                    <div>
                                        <br></br>
                                        <ColumnLayout borders="vertical" columns={2} >
                                            <SpaceBetween direction='vertical' size='m'>
                                                {showFileNotSeleted ? <Alert type='error'>File Not Selected</Alert> : ''}
                                                {
                                                      showUploadBtn ? <FileUpload
                                                        onChange={({ detail }) => { setInputFiles(detail.value); changeHandler(detail.value) }}
                                                        value={inputFiles}
                                                        i18nStrings={{
                                                            uploadButtonText: e =>
                                                                e ? "Choose files" : "Choose file",
                                                            dropzoneText: e =>
                                                                e
                                                                    ? "Drop files to generate"
                                                                    : "Drop file to generate",
                                                            removeFileAriaLabel: e =>
                                                                `Remove file ${e + 1}`,
                                                            limitShowFewer: "Show fewer files",
                                                            limitShowMore: "Show more files",
                                                            errorIconAriaLabel: "Error"
                                                        }}
                                                        showFileLastModified
                                                        showFileSize
                                                        showFileThumbnail
                                                        tokenLimit={1}
                                                        accept={supportedFormats}
                                                        constraintText="upload input file"
                                                    /> : <Box></Box>
                                                }
                                                
                                                {
                                                    comments ? <Alert
                                                        statusIconAriaLabel="Info"
                                                        header="Dates"
                                                    >
                                                        {comments?.split("\n")?.map((t, key) => {
                                                            return <p key={key}>{t}</p>;
                                                        })}


                                                    </Alert> : ''
                                                }

                                                {errorMessage? <Alert statusIconAriaLabel="Error"
                                                type="error"
                                                header="Upload restricted"> 
                                                {errorMessage} </Alert>:''}

                                                {
                                                    rulesSheetNotPresent ? (
                                                        <>
                                                    <Alert
                                                    statusIconAriaLabel="Error"
                                                    type="error"
                                                    header="Rules Sheet is missing"
                                                    >
                                                    Please make sure rules sheet is present, and in the format mentioned on the right.
                                                    </Alert>
                                                        </>
                                                    ) : <></>
                                                
                                                }

                                                { (missingFields.size >= 1 || colCountNotAsExpected || colsNotInRequiredOrder) ? (
                                                    <>
                                                    <Box>
                                                    <h4>Validation checks:</h4>
                                                    <ul>
                                                        <li>
                                                        All required fields available? {missingFields.size >= 1 ? <Icon name="status-negative"  variant="error"/> : <Icon name="status-positive"  variant="success"/>}
                                                        </li>
                                                        <li>
                                                        Provided column(s) count is equal to expected column count? {colCountNotAsExpected ? <Icon name="status-negative"  variant="error"/> : <Icon name="status-positive"  variant="success"/>}
                                                        </li>
                                                        <li>
                                                        Column order as expected? (Please refer required column order on the right) {colsNotInRequiredOrder ? <Icon name="status-negative"  variant="error"/> : <Icon name="status-positive"  variant="success"/>}
                                                        </li>
                                                    </ul>
                                                    </Box>
                                                {
                                                    (missingFields.size >= 1 && 
                                                    
                                                    <Alert
                                                        statusIconAriaLabel="Error"
                                                        type="error"
                                                        header="Required fields are missing"
                                                    >
                                                    <SpaceBetween>
                                                     <Box><h4>Missing Fields:</h4>
                                                     <ul>
                                                        {Array.from(missingFields).map((field) => (
                                                            <li key={field}>{field}</li>
                                                        ))}
                                                     </ul>
                                                     </Box>  
                                                     <Box><h4>Provided Fields:</h4>
                                                     <ul>
                                                     {providedCoulumns.map((field) => (
                                                            <li key={field}>{field}</li>
                                                        ))}
                                                     </ul>
                                                     </Box>
                                                     </SpaceBetween>
                                                    </Alert>
                                                    )
                                                }
                                                
                                                </>
                                                ):<></>

                                                }
                                                
                                            </SpaceBetween>


                                


                                            <Box>
                                                <ExpandableSection header="The Rules sheet in the file should contain the following columns in below order." 
                                                defaultExpanded>
                                                    <ul>
                                                        {
                                                            RULES_SHEET_COLUMNS.map(
                                                                column => <li
                                                                    value={column}
                                                                    key={column}>
                                                                    <span>{column}</span>
                                                                    <span className='missing'> {(missingFields && missingFields.size > 0 && missingFields.has(column)) ? ' - required' : ''} </span>
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </ExpandableSection>

                                            </Box>


                                        </ColumnLayout>

                                    </div>

                                )
                            },
                            {
                                label: "Step 2 : Review File",
                                id: "second",
                                content: (
                                    <Box>
                                        <Header
                                            variant="h2"
                                            description="File preview - Read Only"
                                            actions={
                                                <SpaceBetween
                                                    direction="horizontal"
                                                    size="xs"
                                                >
                                                    <Button variant="normal" onClick={prevButtonClick}>Previous</Button>

                                                    <Button variant="primary" onClick={next1Click}>Next</Button>
                                                    <Box></Box>
                                                </SpaceBetween>
                                            }
                                        />
                                        <Table
                                            columnDefinitions={columnsList}
                                            items={previewItems}
                                            stickyHeader={true}
                                            resizableColumns={true}
                                        >

                                        </Table>
                                    </Box>
                                )
                            },
                            {
                                label: "Step 3 : Submit",
                                id: "third",
                                content: (<div>
                                    <Header
                                        variant="h2"
                                        description="File Details"
                                        actions={
                                            <SpaceBetween
                                                direction="horizontal"
                                                size="xs"
                                            >
                                                <Button variant="normal" onClick={cancelButtonClick} disabled={submitDisabled}>Cancel</Button>
                                                <Button variant="primary" onClick={onSubmitClick} disabled={submitDisabled}>Submit</Button>
                                            </SpaceBetween>
                                        }
                                    />


                                    <ColumnLayout columns={3}>
                                        < Box>
                                            Filename: {fileName}
                                            {mainErrorMessage && (
                                                <div className="custom-new-upload__error-message"> {mainErrorMessage} </div>
                                            )}
                                        </Box>
                                    </ColumnLayout>
                                </div>),
                            }
                        ]}
                    />
                </SpaceBetween>

                <Modal
                    visible={showSuccessModal}
                    footer={
                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="primary" onClick={ModalOkClick}>Ok</Button>
                            </SpaceBetween>
                        </Box>
                    }
                    header="File Upload Status"
                >
                    <Box>
                        <SpaceBetween size='m' direction='vertical'>
                            <p>
                                <Icon variant="success" size='medium' name='status-positive'></Icon>
                                &nbsp; &nbsp;
                                Your file has been uploaded for processing. <br></br>
                                File reference : {fileReference}
                            </p>

                        </SpaceBetween>

                    </Box>

                    <br></br>

                </Modal>

            </div>
        </div>
    )
    return (
        <AppLayout
            content={content}
            navigation={ <SideNav activeHref={`/App/${id}/LogicoProcess/${lpid}/upload`} id={id} lpid={lpid} process={processData} back={backUrl} />}
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant={"high-contrast"}
            contentType="table"
        ></AppLayout>
    );
}
